import React, { FunctionComponent, useState, useEffect } from 'react';
import { useTheme } from '@mui/material/styles';
// import { useNavigate, useLocation } from 'react-router-dom';
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { useAtom } from 'jotai';
import { useTranslation } from 'react-i18next'
// import useMediaQuery from '@mui/material/useMediaQuery';

// import { check_subdomain } from '../../lib/server_helper';
import { fetch_all } from "../../../../lib/v31lib";
import { loginAtom } from '../../../../lib/auth';
import { currentPracticeAtom } from '../../../../lib/practice';

import QuestionMarkIcon from '@mui/icons-material/QuestionMark';
import PanToolAltIcon from '@mui/icons-material/PanToolAlt';

import {
  Avatar,
  Box,
  CircularProgress,
  IconButton,
  List,
  ListItem,
  ListItemAvatar,
  ListItemSecondaryAction,
  ListItemText,
  Paper,
} from '@mui/material';

import {
  Button,
  Switcher,
  Typography
} from '../../../../components/v2/styled';
import { ListItemCoach } from '../../../../components/v2/list_items/Coach';
import HelpersAppointmentCombos from '../../../../actions/helpers/appointment_combos';

import { AppointmentType } from '../../../../models/AppointmentType';
import { Practice } from '../../../../models/Practice';
import { User } from '../../../../models/User';

// const { DateTime } = require("luxon");

type Props = {
  noCoach: boolean;
  selectedCoach?: User;
  selectedType: AppointmentType;
  setNoCoach: (d:boolean) => void;
  setSelectedCoach: (d:User|undefined) => void;
  activePractice?: Practice;
}

export const ClientAppointmentNewStepCoach: FunctionComponent<Props> = ({activePractice, selectedType, selectedCoach, setSelectedCoach, noCoach, setNoCoach}) => {
  const [login, setLogin] = useAtom(loginAtom);
  const [currentPractice, setCurrentPractice] = useAtom(currentPracticeAtom);
  const theme = useTheme();
  // const navigate = useNavigate();
  const {t, i18n} = useTranslation(['translations']);
  // const queryClient = useQueryClient();
  // const { state } = useLocation();

  // const matchesmd = useMediaQuery(theme.breakpoints.up('md'));

  // const [currentDay, setCurrentDay] = useState<string>(!!state && !!state.day ? state.day : DateTime.now().toFormat("dd/LL/y"));
  const {
    data: coaches,
    // isLoading: coachesLoading,
    // isError: coachesError,
    isSuccess: coachesSuccess,
    // refetch: coachesRefetch,
  } = useQuery({
    queryKey: ["coach", activePractice?.id],
    queryFn: () =>
      fetch_all<User>(
        `/${i18n.resolvedLanguage || 'nl'}/v3/pub/fetch_all`,
        {
          object: 'coach',
          fields: [
            'id', 'full_name', 'coach_skills', 'get_medium', 'enabled', 'practice_id'
          ],
          page: 0,
          per_page: 1000,
          order: "sort_order ASC, first_name ASC, last_name ASC",
          filter: {
            search: '',
            advanced: {
              practice_id: activePractice?.id,
              enabled: 1,
              is_secretary: 0,
              with_roster: 1
            }
          }
        },
        login
      ),
    // select: (d) => {
    //   hasVideo = d.filter(ff => ff.is_meeting).length > 0;
    //   hasPhysical = d.filter(ff => !ff.is_meeting).length > 0;
    //   return d;
    // },
    enabled: !!activePractice?.id,
  });






  useEffect(() => {
    const valid = (coaches || []).filter(ff => HelpersAppointmentCombos.coachIsValidForType(ff, selectedType));
    if (valid.length == 1) setSelectedCoach(valid[0]);
  }, [coaches, selectedType]);
  
  return <Paper sx={{
    padding: 2
  }}>
    {!coachesSuccess && <Box><CircularProgress /></Box>}
    {coachesSuccess && <Box>
      {!(!!selectedCoach || !!noCoach) && coaches.filter(ff => (selectedType.coaches || []).length === 0 || (selectedType.coaches || []).indexOf(ff.id || 0) === -1).length > 0 && <Typography variant={"subtitle2"}>{t("client.appointment.pick_coach")}:</Typography>}
      {/* {!selectedCoach && coaches.filter(ff => (selectedType.coaches || []).length === 0 || (selectedType.coaches || []).indexOf(ff.id || 0) === -1).length > 1 && <Switcher
        id="no_coach"
        caption={t("client.appointment.no_coach", "Coach maakt niet uit")}
        backend
        value={noCoach}
        onChange={(c) => {setNoCoach(c);}}
        sx={{marginTop: 2}}
      />} */}
      {(!!selectedCoach || !!noCoach) && <>
        <Typography variant={"subtitle2"}>{t("client.appointment.selected_coach")}:</Typography>
        <List>
          {!!selectedCoach && <ListItemCoach coach={selectedCoach} />}
          {!!noCoach && <ListItem onClick={() => {
            setNoCoach(true);
          }} sx={{cursor: 'pointer'}}>
            <ListItemAvatar>
              <Avatar><QuestionMarkIcon /></Avatar>
            </ListItemAvatar>
            <ListItemText>{t("client.appointment.no_coach", "Coach maakt niet uit")}</ListItemText>
            <ListItemSecondaryAction>
              <IconButton edge="end" aria-label="settings" onClick={(e) => {
                e.preventDefault();
                setNoCoach(true);
              }}>
                <PanToolAltIcon />
              </IconButton>
            </ListItemSecondaryAction>
          </ListItem>}
        </List>
        {coaches.filter(ff => (selectedType.coaches || []).length === 0 || (selectedType.coaches || []).indexOf(ff.id || 0) === -1).filter(fff => selectedCoach?.id !== fff.id).length > 0 && <Button
          id="unselect"
          label={t("client.appointment.unpick_coach")}
          onClick={() => {
            setSelectedCoach(undefined);
            setNoCoach(false);
          }}
          text
          size='small'
          sx={{
            marginTop: 1
          }}
        />}
      </>}

      {!(!!selectedCoach || !!noCoach) && coaches.filter(ff => (selectedType.coaches || []).length === 0 || (selectedType.coaches || []).indexOf(ff.id || 0) === -1).length === 0 && <Typography variant={"subtitle2"}>{t("client.appointment.no_coaches", "Er zijn geen coaches beschikbaar voor dit afspraaktype.")}</Typography>}

      {!(!!selectedCoach || !!noCoach) && <List>
        <ListItem onClick={() => {
          setNoCoach(true);
        }} sx={{cursor: 'pointer'}}>
          <ListItemAvatar>
            <Avatar><QuestionMarkIcon /></Avatar>
          </ListItemAvatar>
          <ListItemText>{t("client.appointment.no_coach", "Coach maakt niet uit")}</ListItemText>
          <ListItemSecondaryAction>
            <IconButton edge="end" aria-label="settings" onClick={(e) => {
              e.preventDefault();
              setNoCoach(true);
            }}>
              <PanToolAltIcon />
            </IconButton>
          </ListItemSecondaryAction>
        </ListItem>
        {coaches.filter(ff => (selectedType.coaches || []).length === 0 || (selectedType.coaches || []).indexOf(ff.id || 0) === -1).map(coach => (<>
          {(!selectedCoach) && <ListItemCoach coach={coach} onClick={() => {
            setSelectedCoach(coach);
          }} />}
        </>))}
      </List>}
    </Box>}
  </Paper>;
}

